import { z } from 'zod';
import { CargoProblemTerminalOutcomeSchema } from './status.js';
import { CARGO_PROBLEM_COMMENT_MAX, CargoProblemTransitionActionSchema } from './vocab.js';

export function makeCargoProblemTransitionInputSchema<T extends z.ZodRawShape>(extra: T) {
  return z
    .object({
      action: CargoProblemTransitionActionSchema,
      note: z.string().trim().min(1).max(CARGO_PROBLEM_COMMENT_MAX).optional(),
      outcome: CargoProblemTerminalOutcomeSchema.optional(),
      ...extra,
    })
    .strict()
    .superRefine((input, ctx) => {
      const action = input.action;
      if (!action) return;
      const requiresNote = ['reject', 'submitReview', 'evaluate'].includes(action);
      if (requiresNote && !input.note) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['note'], message: 'note is required' });
      }
      if (action === 'evaluate' && !input.outcome) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['outcome'],
          message: 'outcome is required',
        });
      }
      if (action !== 'evaluate' && input.outcome !== undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['outcome'],
          message: 'outcome is allowed only for evaluate',
        });
      }
    });
}
